import type { AxiosRequestConfig } from "axios";
import type { SkipTokenRefreshConfig } from "../Api/Plugin/RefreshToken/RefreshTokenResponseInterceptor";
import { api } from "../Api/api";

// A token pair that was just issued (login or refresh) and is refused anyway is an outage: refreshing again cannot
// fix it. Worse, inside a refresh the retry would wait on the refresh that is still busy loading this user.
const FRESH_TOKEN_CONFIG: AxiosRequestConfig & SkipTokenRefreshConfig = {
  skipTokenRefresh: true,
};

/**
 * Loads the current user right after a new token pair was stored. This is its own request on purpose: a shared
 * query would join a `/api/users/me` request still in flight with the previous token, which may itself be waiting
 * for this very refresh to finish.
 */
export async function fetchCurrentUserWithFreshToken<T>(): Promise<T> {
  const { data } = await api.get<T>("/api/users/me", FRESH_TOKEN_CONFIG);
  return data;
}
